var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightTabbarMarketSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "light_tabbar_market_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB8EB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB8EB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB8EB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-63, -58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(66, 61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.32,0.762102355 L21.0723048,5.23789764 C21.8891237,5.70948822 22.3923048,6.58102355 22.3923048,7.52420471 L22.3923048,16.4757953 C22.3923048,17.4189764 21.8891237,18.2905118 21.0723048,18.7621024 L13.32,23.2378976 C12.5031812,23.7094882 11.4968188,23.7094882 10.68,23.2378976 L2.92769515,18.7621024 C2.11087631,18.2905118 1.60769515,17.4189764 1.60769515,16.4757953 L1.60769515,7.52420471 C1.60769515,6.58102355 2.11087631,5.70948822 2.92769515,5.23789764 L10.68,0.762102355 C11.4968188,0.290511777 12.5031812,0.290511777 13.32,0.762102355 Z",
    id: "\\u591A\\u8FB9\\u5F62",
    stroke: "#0E1C39",
    strokeWidth: 2,
    fill: "#0E1C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4.53846154 C12.5522847,4.53846154 13,4.98617679 13,5.53846154 L13,18.4615385 C13,19.0138232 12.5522847,19.4615385 12,19.4615385 C11.4477153,19.4615385 11,19.0138232 11,18.4615385 L11,5.53846154 C11,4.98617679 11.4477153,4.53846154 12,4.53846154 Z",
    id: "\\u8DEF\\u5F84-2",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38461538,9.15384615 C7.93690013,9.15384615 8.38461538,9.6015614 8.38461538,10.1538462 L8.38461538,15.6923077 C8.38461538,16.2445924 7.93690013,16.6923077 7.38461538,16.6923077 C6.83233063,16.6923077 6.38461538,16.2445924 6.38461538,15.6923077 L6.38461538,10.1538462 C6.38461538,9.6015614 6.83233063,9.15384615 7.38461538,9.15384615 Z",
    id: "\\u8DEF\\u5F84-2",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6153846,7.30769231 C17.1676694,7.30769231 17.6153846,7.75540756 17.6153846,8.30769231 L17.6153846,15.6923077 C17.6153846,16.2445924 17.1676694,16.6923077 16.6153846,16.6923077 C16.0630999,16.6923077 15.6153846,16.2445924 15.6153846,15.6923077 L15.6153846,8.30769231 C15.6153846,7.75540756 16.0630999,7.30769231 16.6153846,7.30769231 Z",
    id: "\\u8DEF\\u5F84-2",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTabbarMarketSelected);
export default __webpack_public_path__ + "static/media/light_tabbar_market_selected.c5d7033b8d891bd929c3c06d9d470cc0.svg";
export { ForwardRef as ReactComponent };